import type { IMaskFunction } from 'interfaces/IMask';

const creditcard: IMaskFunction = {
  apply: (value: string) => {
    if (!value) return value;
    const regexp = /^(\d{0,4})?(\d{0,4})?(\d{0,4})?(\d{0,4})?/;
    return value.replace(regexp, '$1 $2 $3 $4').replace(/-$/, '').trim();
  },
  clean: (value: string) => value.replace(/\D/gi, '').substr(0, 16),
};

export default creditcard;
